import React from 'react';
import LinkCardDescription from '@/components/cards/LinkCardDescription';

const VocabularyUrlCard = ({ vocabulary }) => (
  <LinkCardDescription value={vocabulary.value} />
);

export default VocabularyUrlCard;
